export default __webpack_public_path__ + "static/faces-banner-face-3fbba11139d43c626e6a34ff9a3af962.jpg";